import React from 'react';

import { ModalActions, ModalContext } from '@contexts/index';

export function useModal() {
  const context = React.useContext(ModalContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useModal must be used within a ModalProvider`);
  }

  const { state, dispatch } = context;

  const openModal = (props: {
    children: React.ReactNode;
    width: number | 'full';
    props?: Record<string, string>;
    isPersistent?: boolean;
  }) => {
    dispatch({ type: ModalActions.Open, ...props });
  };

  const closeModal = () => {
    dispatch({ type: ModalActions.Close });
  };

  const toggleModal = () => {
    dispatch({ type: ModalActions.Toggle });
  };

  const setContent = (props: { children: React.ReactNode }) => {
    dispatch({ type: ModalActions.SetChildren, ...props });
  };

  const resetModal = () => {
    dispatch({ type: ModalActions.Reset });
  };

  return {
    state,
    dispatch,
    openModal,
    closeModal,
    setContent,
    toggleModal,
    resetModal,
  };
}
